import { useSearchParams } from 'react-router-dom'

/** Shared list-page URL query params (sort, page, query) read by the user list
 * hooks (useActiveUsers and useUsersIndex). Keeps the identical search-param
 * parsing in one place. */
export function useUserListQueryParams() {
  const [searchParams] = useSearchParams()
  const sort = searchParams.get(`sort`) === `` ? undefined : (searchParams.get(`sort`) ?? `name.keyword`)
  const page = Number(searchParams.get(`page`) || 0)
  const query = searchParams.get(`query`) ?? ``

  return { searchParams, sort, page, query }
}
